import { render, staticRenderFns } from "./route-info-dashbord-header.vue?vue&type=template&id=24ca2bba&scoped=true&"
import script from "./route-info-dashbord-header.vue?vue&type=script&lang=ts&"
export * from "./route-info-dashbord-header.vue?vue&type=script&lang=ts&"
import style0 from "./route-info-dashbord-header.vue?vue&type=style&index=0&id=24ca2bba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca2bba",
  null
  
)

export default component.exports